import {LK_ROOT_ELEMENT_ID} from 'lib/constants';

export function getLkBasename() {
    const rootElement = document.getElementById(LK_ROOT_ELEMENT_ID);
    const baseurl = rootElement?.getAttribute('data-baseurl');
    return baseurl ?? '/lk';
}
